if (!customElements.get('sky-option-help')) {
  customElements.define(
    'sky-option-help',
    class SkyOptionHelp extends HTMLElement {
      constructor() {
        super();
        this.onTriggerClick = this.onTriggerClick.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
        this.onPanelClick = this.onPanelClick.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
      }

      connectedCallback() {
        this.trigger = this.querySelector('.sky-option-help-trigger');
        this.panel = this.querySelector('.sky-option-help-panel');
        this.closeButton = this.querySelector('.sky-option-help-close');

        if (!this.trigger || !this.panel) return;
        if (this.isBound) return;

        this.trigger.addEventListener('click', this.onTriggerClick);
        this.panel.addEventListener('click', this.onPanelClick);
        this.closeButton?.addEventListener('click', this.onCloseClick);
        this.isBound = true;
      }

      disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.onTriggerClick);
        this.panel?.removeEventListener('click', this.onPanelClick);
        this.closeButton?.removeEventListener('click', this.onCloseClick);
        this.isBound = false;
        this.removeGlobalListeners();
      }

      onTriggerClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.toggle();
      }

      onCloseClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.close(true);
      }

      onPanelClick(event) {
        event.stopPropagation();
      }

      toggle() {
        if (this.panel.hidden) {
          this.open();
        } else {
          this.close(true);
        }
      }

      open() {
        SkyOptionHelp.closeAll(this);
        this.panel.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');

        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onKeydown);
      }

      close(restoreFocus = false) {
        if (!this.panel || this.panel.hidden) return;

        this.panel.hidden = true;
        this.trigger?.setAttribute('aria-expanded', 'false');
        this.removeGlobalListeners();

        if (restoreFocus) this.trigger?.focus();
      }

      removeGlobalListeners() {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onKeydown);
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) this.close(false);
      }

      onKeydown(event) {
        if (event.key === 'Escape') this.close(true);
      }

      static closeAll(exceptElement) {
        document.querySelectorAll('sky-option-help').forEach((element) => {
          if (element !== exceptElement) element.close(false);
        });
      }
    }
  );
}
